module.exports = __webpack_public_path__ + "static/img/ke06_benefit.d747033d.png";